/* eslint-disable */
import AllSpecifications from 'containers/Specifications/AllSpecifications';
import Filters from 'containers/Specifications/Filters/Filters';
import FolderCreator from 'containers/Specifications/FolderCreator/FolderCreator';
import FolderView from 'containers/Specifications/FolderView';
import Breadcrumbs from 'layout/atoms/Breadcrumbs/Breadcrumbs';
import Grid from 'layout/molecules/Grid/Grid';
import Sticky from 'layout/molecules/Sticky';
import React, { memo, useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { Redirect, Route, Switch, useHistory, withRouter } from 'react-router';
import { fetchRootFolder, fetchRootFolders, selectFolderName, selectFoldersTree, selectRootFolder, } from 'store/specificationsFoldersSlice';
const SpecificationsPicker = ({ match }) => {
    var _a, _b, _c;
    const { t, i18n } = useTranslation(['specification', 'common', 'orders']);
    const dispatch = useDispatch();
    const history = useHistory();
    const layout = useSelector((state) => state.layout);
    const rootFolder = useSelector(selectRootFolder);
    const { orderId } = match.params;
    const url = match.url;
    const folderId = ((_a = location.pathname.match(/folders\/([^/]+)/)) === null || _a === void 0 ? void 0 : _a[1]) || (rootFolder === null || rootFolder === void 0 ? void 0 : rootFolder.rootFolderId);
    const folderName = useSelector((state) => selectFolderName(state, folderId));
    const foldersTree = useSelector(selectFoldersTree);
    const memoFoldersTree = useMemo(() => foldersTree, [foldersTree]);
    useEffect(() => {
        dispatch(fetchRootFolder());
    }, [dispatch]);
    useEffect(() => {
        if (rootFolder.rootFolderId !== null) {
            dispatch(fetchRootFolders({ folderId: rootFolder.rootFolderId }));
        }
    }, [dispatch, rootFolder.status, rootFolder.rootFolderId]);
    const generateBreadcrumbs = (folders, currentFolderId) => {
        const breadcrumbs = [];
        let currentFolder = folders.find((folder) => folder.id === currentFolderId);
        while (currentFolder) {
            breadcrumbs.unshift({
                id: currentFolder.id,
                to: `${match.url}/folders/${currentFolder.id}`,
                name: currentFolder.name,
            });
            // eslint-disable-next-line no-loop-func
            currentFolder = folders.find((folder) => folder.id === currentFolder.parentId);
        }
        return breadcrumbs;
    };
    const folderBreadcrumbs = memoFoldersTree ? generateBreadcrumbs(memoFoldersTree, folderId) : [];
    return (React.createElement(React.Fragment, null,
        React.createElement(Grid, { vp: 12, hp: 24, gap: 0 },
            React.createElement(Switch, null,
                React.createElement(Route, { exact: true, path: `${match.url}/my-files` },
                    React.createElement(React.Fragment, null,
                        React.createElement(Breadcrumbs, { items: [
                                {
                                    id: 'specifications/',
                                    to: match.url,
                                    name: t('specification_capitalize_plural'),
                                },
                                { id: 'my_files', to: `${match.url}/my-files`, name: t('my_files') },
                            ] }),
                        React.createElement("h2", null, t('my_files')))),
                React.createElement(Route, { exact: true, path: `${match.url}/folders/:folderId` },
                    React.createElement(React.Fragment, null,
                        React.createElement(Breadcrumbs, { items: [
                                {
                                    id: '/specifications/',
                                    to: match.url,
                                    name: t('specification_capitalize_plural'),
                                },
                                ...folderBreadcrumbs,
                            ] }),
                        React.createElement("h2", null, folderId === rootFolder.rootFolderId ? t('all_folders') : folderName))))),
        React.createElement(Sticky, { shadow: true },
            React.createElement(Switch, null,
                React.createElement(Route, { exact: true, path: `${match.url}/my-files` },
                    React.createElement(Filters, null)),
                React.createElement(Route, { exact: true, path: `${match.url}/folders/:folderId` },
                    React.createElement(Filters, { folders: true })))),
        React.createElement(Grid, { vp: 12, hp: 24 },
            React.createElement(Switch, null,
                React.createElement(Route, { exact: true, path: `${match.url}/my-files` },
                    React.createElement(AllSpecifications, { orderSelect: true })),
                React.createElement(Route, { exact: true, path: `${match.url}/latest` },
                    React.createElement(AllSpecifications, { orderSelect: true, latest: true })),
                React.createElement(Route, { exact: true, path: `${match.url}/drafts` },
                    React.createElement(AllSpecifications, { orderSelect: true, drafts: true })),
                React.createElement(Route, { exact: true, path: `${match.url}/folders/:folderId` },
                    React.createElement(FolderView, { link: `${match.url}/folders`, orderSelect: true })),
                React.createElement(Route, { exact: true, path: match.url }, (rootFolder === null || rootFolder === void 0 ? void 0 : rootFolder.rootFolderId) && (React.createElement(Redirect, { to: `${url}/folders/${rootFolder === null || rootFolder === void 0 ? void 0 : rootFolder.rootFolderId}` })))),
            ((_b = layout.showModals) === null || _b === void 0 ? void 0 : _b.some((modal) => modal.name === 'folderCreator')) && (React.createElement(FolderCreator, { parentFolder: folderId })),
            ((_c = layout.showModals) === null || _c === void 0 ? void 0 : _c.some((modal) => modal.name === 'folderEditor')) && (React.createElement(FolderCreator, { edit: true })))));
};
export default memo(withRouter(SpecificationsPicker));
